export default "__VITE_ASSET__Bg6LK2AG__"